import rootReducer, { RootState } from "@redux/rootReducer";
import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector as useReduxSelector, type TypedUseSelectorHook } from "react-redux";

const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
export default store;
